export default "__VITE_ASSET__0d2cd996__"